export default function EmptyState({ title, message, icon: Icon, action, testId }) {
    return (
        <div className="flex flex-col items-center justify-center py-14 px-6 text-center rounded-lg border border-dashed border-border bg-muted/30" data-testid={testId}>
            {Icon ? (
                <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
                    <Icon className="h-6 w-6" strokeWidth={1.75} />
                </div>
            ) : null}
            <h3 className="font-display text-lg font-semibold">{title}</h3>
            {message && <p className="mt-1 text-sm text-muted-foreground max-w-md">{message}</p>}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
}
